/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Carrier_Form_Rejected_Without_DetailsInputs */

const vi_carrier_form_rejected_without_details = /** @type {(inputs: Carrier_Form_Rejected_Without_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Viettel Post từ chối yêu cầu. Kiểm tra lại thông tin vận đơn rồi thử lại.`)
};

/**

* @param {Carrier_Form_Rejected_Without_DetailsInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const carrier_form_rejected_without_details = /** @type {((inputs?: Carrier_Form_Rejected_Without_DetailsInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Carrier_Form_Rejected_Without_DetailsInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_carrier_form_rejected_without_details(inputs)
});